export const adsScript: any = {
  "/": {
    homeSobeysApp: {
      id: "div-gpt-ad-1747629323892-0",
      slotPath: "/22966717622/sobeys_get_sobeys_app_dxp",
      sizes: ["fluid"],
      addSize: [],
    },
    homeBanner1: {
      id: "div-gpt-ad-1747629444319-0",
      slotPath: "/22966717622/Sobeys_home_carousel_1",
      sizes: ["fluid"],
      addSize: [],
    },
    homeBanner2: {
      id: "div-gpt-ad-1749299294229-0",
      slotPath: "/22966717622/Sobeys_home_carousel_2",
      sizes: ["fluid"],
      addSize: [],
    },
    homeBanner3: {
      id: "div-gpt-ad-1749299374502-0",
      slotPath: "/22966717622/Sobeys_home_carousel_3",
      sizes: ["fluid"],
      addSize: [],
    },
    // customAd: {
    //   id: `div-gpt-ad-5093543-1`,
    //   slotPath: `/22966717622/sobeys_homepage_top_1920x250-480x200_dxp`,
    //   sizes: [
    //     [1920, 250],
    //     [480, 200],
    //     [834, 250],
    //   ],
    //   addSize: [
    //     [
    //       [1024, 0],
    //       [1920, 250],
    //     ],
    //     [
    //       [830, 0],
    //       [834, 250],
    //     ],
    //   ],
    // },
    AdCard: {
      id: `div-gpt-ad-1745921120713-0`,
      slotPath: `/22966717622/sobeys_dxp_708x464`,
      sizes: [[708, 464]],
      addSize: [
        [
          [1024, 0],
          [708, 464],
        ],
      ],
    },
    leaderboard_B: {
      id: `div-gpt-ad-6196258-1`,
      slotPath: `/22966717622/sobeys_homepage_top_728x90-320x50_dxp`,
      sizes: [
        [728, 90],
        [320, 50],
      ],
      addSize: [
        [
          [1024, 0],
          [728, 90],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [200, 0],
          [270, 50],
        ],
      ],
    },
    leaderboard_A: {
      id: "div-gpt-ad-1739264297477-0",
      slotPath: "/22966717622/sobeys_native_970x250_template_dxp",
      sizes: ["fluid"],
      addSize: [],
    },
    // middle1: {
    //   id: `div-gpt-ad-1738151361656-0`,
    //   slotPath: `/22966717622/sobeys_homepage_middle1_342x285_dxp`,
    //   sizes: [
    //     [212, 176],
    //     [342, 285],
    //   ],
    //   addSize: [
    //     [
    //       [1024, 0],
    //       [342, 285],
    //     ],
    //     [
    //       [768, 0],
    //       [342, 285],
    //     ],
    //     [
    //       [300, 0],
    //       [212, 176],
    //     ],
    //   ],
    // },
    // middle2: {
    //   id: `div-gpt-ad-1738151439661-0`,
    //   slotPath: `/22966717622/sobeys_homepage_middle2_342x285_dxp`,
    //   sizes: [
    //     [212, 176],
    //     [342, 285],
    //   ],
    //   addSize: [
    //     [
    //       [1024, 0],
    //       [342, 285],
    //     ],
    //     [
    //       [768, 0],
    //       [342, 285],
    //     ],
    //     [
    //       [300, 0],
    //       [212, 176],
    //     ],
    //   ],
    // },
    double_image: {
      id: `div-gpt-ad-1739947227069-0`,
      slotPath: `/22966717622/Double_images`,
      sizes: ["fluid"],
      addSize: [],
    },
    // bottom: {
    //   id: `div-gpt-ad-1737547032087-0`,
    //   slotPath: `/22966717622/sobeys_homepage_bottom_464x410_dxp1`,
    //   sizes: [[464, 410]],
    //   addSize: [
    //     [
    //       [1024, 0],
    //       [464, 410],
    //     ],
    //     [
    //       [768, 0],
    //       [342, 285],
    //     ],
    //     [
    //       [768, 0],
    //       [212, 176],
    //     ],
    //   ],
    // },
    // sobeys_homepage_bottom_728x90: {
    //   id: `div-gpt-ad-1738153158850-0`,
    //   slotPath: `/22966717622/sobeys_homepage_bottom_728x90-320x50_dxp`,
    //   sizes: [
    //     [320, 50],
    //     [728, 90],
    //     [270, 90],
    //   ],
    //   addSize: [
    //     [
    //       [1024, 0],
    //       [728, 90],
    //     ],
    //     [
    //       [768, 0],
    //       [728, 90],
    //     ],
    //     [
    //       [350, 0],
    //       [320, 50],
    //     ],
    //     [
    //       [100, 0],
    //       [270, 50],
    //     ],
    //   ],
    // },
    // Middle_mobile: {
    //   id: `div-gpt-ad-1738155006102-0`,
    //   slotPath: `/22966717622/sobeys_homepage_mobile-middle_432x362_dxp`,
    //   sizes: [[432, 362]],
    //   addSize: [
    //     [
    //       [300, 0],
    //       [432, 362],
    //     ],
    //   ],
    // },
  },
  "/recipes": {
    leaderboardTop_A: {
      id: `div-gpt-ad-1738647053957-0`,
      slotPath: `/22966717622/sobeys_recipe-page_leaderboard_970x250_dxp`,
      sizes: [
        [728, 90],
        [970, 250],
        [320, 50],
        [270, 50],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1310, 0],
          [970, 250],
        ],
      ],
    },
    rectangleMiddle_A: {
      id: `div-gpt-ad-1737550439749-0`,
      slotPath: `/22966717622/sobeys_recipe-page_middle_220x194_dxp`,
      sizes: [[220, 194]],
      addSize: [],
    },
    leaderboardBottom_A: {
      id: `div-gpt-ad-1738647551904-0`,
      slotPath: `/22966717622/sobeys_recipe-page_bottom_970x250_dxp`,
      sizes: [
        [970, 250],
        [728, 90],
        [320, 50],
        [270, 50],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1310, 0],
          [970, 250],
        ],
      ],
    },
    leaderboardTop_B: {
      id: `div-gpt-ad-1738647696473-0`,
      slotPath: `/22966717622/sobeys_recipe-page_leaderboard_728x90_dxp`,
      sizes: [
        [
          [320, 50],
          [728, 90],
          [270, 50],
        ],
      ],
      addSize: [
        [
          [1200, 0],
          [728, 90],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
      ],
    },
    rectangleMiddle_B: {
      id: `div-gpt-ad-1738647790876-0`,
      slotPath: `/22966717622/sobeys_recipe-page_middle_160x600_dxp`,
      sizes: [[160, 600]],
      addSize: [],
    },
    leaderboardBottom_B: {
      id: `div-gpt-ad-1738735654046-0`,
      slotPath: `/22966717622/sobeys_recipe-page_bottom_728x90_dxp`,
      sizes: [
        [728, 90],
        [320, 50],
        [270, 50],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1024, 0],
          [728, 90],
        ],
      ],
    },
  },
  "/products": {
    leaderboardTop_A: {
      id: `div-gpt-ad-1738567971789-0`,
      slotPath: `/22966717622/sobeys_product-category_billboard_970x250_dxp`,
      sizes: [
        [970, 250],
        [728, 90],
        [320, 50],
        [270, 50],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1310, 0],
          [970, 250],
        ],
      ],
    },
    rectangleMiddle_A: {
      id: `div-gpt-ad-1737547287714-0`,
      slotPath: `/22966717622/sobeys_product-category_middle_220x194_dxp`,
      sizes: [[220, 194]],
      addSize: [],
    },
    leaderboardBottom_A: {
      id: `div-gpt-ad-1738608761954-0`,
      slotPath: `/22966717622/sobeys_product-category_bottom_728x90_dxp`,
      sizes: [
        [728, 90],
        [320, 50],
        [270, 50],
      ],
      addSize: [
        [
          [768, 0],
          [728, 90],
        ],
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
      ],
    },
    leaderboardTop_B: {
      id: `div-gpt-ad-1738568281014-0`,
      slotPath: `/22966717622/sobeys_product-category_billboard_728x90_dxp`,
      sizes: [
        [
          [728, 90],
          [320, 50],
          [270, 50],
        ],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1024, 0],
          [728, 90],
        ],
      ],
    },
    rectangleMiddle_B: {
      id: `div-gpt-ad-1738608665198-0`,
      slotPath: `/22966717622/sobeys_product-category_middle_160x600_dxp`,
      sizes: [[160, 600]],
      addSize: [],
    },
  },
  "/recipes/[slug]": {
    leaderboardBottom: {
      id: `div-gpt-ad-1738643861308-0`,
      slotPath: `/22966717622/sobeys_receipe-detail_bottom_728x90_dxp`,
      sizes: [
        [320, 50],
        [728, 90],
        [270, 50],
      ],
      addSize: [
        [
          [1024, 0],
          [728, 90],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
      ],
    },
  },
  "/products/[slug]": {
    leaderboardTop: {
      id: `div-gpt-ad-1737547623605-0`,
      slotPath: `/22966717622/sobeys_product-detail_leaderboard_728x90_dxp`,
      sizes: [[728, 90]],
      addSize: [],
    },
    leaderboardBottom: {
      id: `div-gpt-ad-1737548317430-0`,
      slotPath: `/22966717622/sobeys_product-detail_below-image_464x58_dxp`,
      sizes: [[464, 58]],
      addSize: [],
    },
  },
  "/flyer": {
    leaderboardTop_A: {
      id: `div-gpt-ad-1738641056630-0`,
      slotPath: `/22966717622/sobeys_flyer-page_top_970x250`,
      sizes: [
        [320, 50],
        [728, 90],
        [970, 250],
        [270, 50],
      ],
      addSize: [
        [
          [1200, 0],
          [970, 250],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
      ],
    },
    leaderboardBottom_A: {
      id: `div-gpt-ad-1738735738078-0`,
      slotPath: `/22966717622/sobeys_flyer-page_bottom_970x250`,
      sizes: [
        [320, 50],
        [728, 90],
        [970, 250],
        [270, 50],
      ],
      addSize: [
        [
          [1200, 0],
          [970, 250],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
      ],
    },
  },
  "/flyer/product": {
    leaderboardTop_A: {
      id: `div-gpt-ad-1738641995878-0`,
      slotPath: `/22966717622/sobeys_flyer-product-page_top_728x90`,
      sizes: [
        [728, 90],
        [320, 50],
        [270, 50],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
      ],
    },
    rectangleMiddle_A: {
      id: `div-gpt-ad-1738642075167-0`,
      slotPath: `/22966717622/sobeys_flyer-product-page_middle_160x600`,
      sizes: [[160, 600]],
      addSize: [],
    },
    leaderboardBottom_A: {
      id: `div-gpt-ad-1738642239088-0`,
      slotPath: `/22966717622/sobeys_flyer-product-page_bottom_728x90`,
      sizes: [
        [728, 90],
        [320, 50],
        [270, 50],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
      ],
    },
    leaderboardTop_B: {
      id: `div-gpt-ad-1738642377691-0`,
      slotPath: `/22966717622/sobeys_flyer-product-page_top_970x250`,
      sizes: [
        [
          [970, 250],
          [320, 50],
          [728, 90],
          [270, 50],
        ],
      ],
      addSize: [
        [
          [1280, 0],
          [970, 250],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
      ],
    },
    leaderboardBottom_B: {
      id: `div-gpt-ad-1738642814070-0`,
      slotPath: `/22966717622/sobeys_flyer-product-page_bottom_970x250`,
      sizes: [
        [970, 250],
        [728, 90],
        [320, 50],
        [270, 50],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1280, 0],
          [970, 250],
        ],
      ],
    },
  },
  "/search": {
    leaderboardTop_A: {
      id: `search-page-top`,
      slotPath: `/22966717622/sobeys_native_970x250_template_dxp_search`,
      sizes: ["fluid"],
      addSize: [],
    },
    // rectangleMiddle_A: {
    //   id: `div-gpt-ad-1737550439749-0`,
    //   slotPath: `/22966717622/sobeys_recipe-page_middle_220x194_dxp`,
    //   sizes: [[220, 194]],
    //   addSize: [],
    // },
    leaderboardBottom_A: {
      id: `div-gpt-ad-1738640713531-0`,
      slotPath: `/22966717622/sobeys_search-result_bottom_728x90_dxp`,
      sizes: [
        [728, 90],
        [320, 50],
        [270, 50],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1024, 0],
          [728, 90],
        ],
      ],
    },
    leaderboardTop_B: {
      id: `fdsfsfdsfs`,
      slotPath: `/22966717622/sobeys_native_728x90_template_dxp`,
      sizes: ["fluid"],
      addSize: [],
    },
    leaderboardBottom_B: {
      id: `div-gpt-ad-1738640799130-0`,
      slotPath: `/22966717622/sobeys_recipe-page_bottom_728x90_dxp`,
      sizes: [
        [728, 90],
        [320, 50],
        [970, 250],
        [270, 50],
      ],
      addSize: [
        [
          [100, 0],
          [270, 50],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1024, 0],
          [970, 250],
        ],
      ],
    },
    rectangleMiddle_B: {
      id: `div-gpt-ad-1738640168528-0`,
      slotPath: `/22966717622/sobeys_search-result_middle_160x600_dxp`,
      sizes: [[160, 600]],
      addSize: [],
    },
    leaderboardTop_C: {
      id: `div-gpt-ad-1738640662989-0`,
      slotPath: `/22966717622/sobeys_search-result_top_728x90_dxp`,
      sizes: [
        [320, 50],
        [728, 90],
        [270, 50],
      ],
      addSize: [
        [
          [1024, 0],
          [728, 90],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [350, 0],
          [320, 50],
        ],
        [
          [100, 0],
          [270, 50],
        ],
      ],
    },
    leaderboardBottom_C: {
      id: `div-gpt-ad-1738640844589-0`,
      slotPath: `/22966717622/sobeys_search-result_bottom_728x90_dxp_C`,
      sizes: [
        [320, 50],
        [728, 90],
      ],
      addSize: [
        [
          [320, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1024, 0],
          [728, 90],
        ],
      ],
    },
  },
  "/articles/[slug]": {
    leaderboardBottom: {
      id: `div-gpt-ad-1738643662045-0`,
      slotPath: `/22966717622/sobeys_article_bottom_728x90`,
      sizes: [
        [
          [320, 50],
          [728, 90],
        ],
      ],
      addSize: [
        [
          [300, 0],
          [270, 50],
        ],
        [
          [360, 0],
          [320, 50],
        ],
        [
          [768, 0],
          [728, 90],
        ],
        [
          [1024, 0],
          [728, 90],
        ],
      ],
    },
  },
};
